// extracted by mini-css-extract-plugin
module.exports = {"langSwitch":"ConfirmForm_langSwitch__3smMX"};